<template>
  <div class="login">
    <main>
      <img class="logo" src="../assets/logo-login.png">
      <br>
      <md-button @click.native="loginGoogle" class="md-raised">
        <img style="width: 40px;" src="../assets/google-icon.png"></img>
        Login Gmail Flux
      </md-button>
    </main>
  </div>
</template>

<script>
  import firebase from '../firebase-config'
  import FluxerService from '../services/fluxer'
  import Router from '../router'

  export default {
    name: 'login',
    methods: {
      loginGoogle () {
        let providerLoginGoole = firebase.google
        let redirect = this.$router.history.current.query.redirect || '/'
        firebase.auth.signInWithPopup(providerLoginGoole).then(function (result) {
          let user = result.user
          var domain = user.email.substr(user.email.indexOf('@') + 1)
          if (domain !== 'fluxit.com.ar') {
            user.delete().then(function () {
              user = null
              alert('Se debe utilizar una cuenta de FluxIT para iniciar la sesion')
            }, function (error) {
              console.log(error)
            })
          } else {
            let keyAuth = Object.keys(localStorage)[0]
            localStorage[keyAuth] = JSON.stringify(user)

            window.OneSignal.push(function () {
              window.OneSignal.sendTag('email', user.email)
            })
            FluxerService.addUser(user)
            Router.replace({path: redirect})
          }
        }).catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code
          var errorMessage = error.message
          // The email of the user's account used.
          var email = error.email
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential
          console.log('Error de auth: ' + errorCode + ' ' + errorMessage + ' ' + email + ' ' + credential)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

body {
  background-color: #e8e8e8
}

.logo {
  margin-bottom: 30px;
}

.login {
  padding: 5% 0;
  background-color: #e8e8e8;
  height: 100%;
  width: 100%
}

</style>



// WEBPACK FOOTER //
// Login.vue?fa2fb6ec